<template>
    <div class="list-cont">
        <div class="list-head">
            <div class="list-item" style="width: 70px;"></div>
            <div class="list-item" v-for="item in valueMap" :style="{width: item.width,flex: !item.width ? 1 : '',textAlign: item.key == 'value3' ? 'center' : ''}">
                {{ item.name }}
            </div>
        </div>
        <div class="list-del" v-for="arr in defaultdata">
            <div class="list-item rank" style="width: 70px;">
                <img src="@/assets/dialog/icon-rank.png" alt="">
            </div>
            <div class="list-item" v-for="item in valueMap" :style="{width: item.width,flex: !item.width ? 1 : ''}">
                <span v-if="item.key !== 'value3'">{{ arr[item.key] }}</span>
                <div class="flex-box" v-else>
                    <div class="list-per">
                        <div class="per-grey"></div>
                        <div class="per-blue" :style="{width: arr[item.key] + '%'}"></div>
                    </div>
                    <span class="per-text">{{ arr[item.key] }}%</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope131",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            isList: true,
            textnum: 127,
            timer: null,
            headlist: [
                { name: '序号', key: 'value1', width: '80px' },
                { name: '产业名称', key: 'value2', width: '140px' },
                { name: '占比', key: 'value3' },
            ],
            defaultdata: [
                { value1: '01', value2: '产业一', value3: 30 },
                { value1: '02', value2: '产业二', value3: 30 },
                { value1: '03', value2: '产业三', value3: 30 },
                { value1: '04', value2: '产业四', value3: 30 },
                { value1: '05', value2: '产业五', value3: 30 },
            ],
            valueMap: [
                { name: "序号", key: "value1" },
                { name: "名称", key: "value2" },
                { name: "占比", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
        },
    },
    methods: {
        ...methods
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
    },
}
</script>

<style lang="scss" scoped>
.list-cont {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    .list-head {
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #9EC2EB;
        line-height: 14px;
        padding-bottom: 14px;
    }
    .list-item {
        &.rank {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 20px;
                height: 14px;
            }
        }
    }
    .list-del {
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #CDD7DD;
        line-height: 14px;
        padding: 12px 0;
        background: rgba(27, 122, 182, .05);
        &:nth-child(2n) {
            background: rgba(27, 122, 182, .16);
        }
        .list-item {
            &:nth-child(2) {
                color: #5BA9F8;
            }
        }
    }
    .flex-box {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .list-per {
        position: relative;
        width: 76px;
        height: 8px;
    }
    .per-grey {
        width: 100%;
        height: 8px;
        background: #273334;
    }
    .per-blue {
        height: 8px;
        background: #00E3E3;
        position: absolute;
        left: 0;
        top: 0;
    }
    .per-text {
        color: #67E0E1;
        margin-left: 12px;
    }
}
</style>